import React, { useEffect } from 'react';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import './my-loot-keys-list.styles.scss'
import PlayerRecordsList from '@/components/SHARED/player-records-list/player-records-list.component';

const MyLootKeysList = ({
  playerData,
  gameElements,
  gameData
}) => {

  useEffect(() => {
    if (!gameData?.gameName) return;
    const pageTitleEl = document.getElementById('page-title');
    if (pageTitleEl) {
      pageTitleEl.innerText = 'Redeemed Loot Keys';
    }
    changeDocumentTitle(`Redeemed Loot Keys | ${gameData?.gameName}`);
  }, [gameData?.gameName])

  return (
    <div className="my-loot-keys-list">
      <PlayerRecordsList
        gameData={gameData}
        playerData={playerData}
        gameElements={gameElements}
        activityType='lootKey'
        title='Redeemed Loot Keys'
        summaryLabel='Redeemed Loot Keys'
        summaryIcon='/images/icons/lootkey.png'
        summaryCount={
          playerData?.lootKeys
            ? Object.keys(playerData.lootKeys).length
            : 0
        }
        emptyText='No redeemed loot keys yet...' />
    </div>
  );
};

export default MyLootKeysList;
